import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const LS_KEY = "oresto-theme";

function applyTheme(theme) {
  if (typeof document === "undefined") return;
  const html = document.documentElement;
  if (theme === "dark") html.classList.add("dark");
  else html.classList.remove("dark");
}

export function useTheme() {
  const [theme, setThemeState] = useState(() => {
    if (typeof window === "undefined") return "light";
    return window.localStorage.getItem(LS_KEY) || "light";
  });
  useEffect(() => { applyTheme(theme); }, [theme]);
  const setTheme = (t) => {
    setThemeState(t);
    try { window.localStorage.setItem(LS_KEY, t); } catch {}
  };
  return { theme, setTheme, toggle: () => setTheme(theme === "dark" ? "light" : "dark") };
}

export default function ThemeToggle({ compact = false }) {
  const { theme, toggle } = useTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      title={theme === "dark" ? "Mode clair" : "Mode nuit"}
      className="flex items-center gap-1.5 px-2 py-1.5 rounded-lg text-sm font-medium text-text-secondary hover:text-[var(--text)] hover:bg-[var(--surface-2)] transition-colors"
    >
      {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
      {!compact && <span className="hidden sm:inline">{theme === "dark" ? "Clair" : "Nuit"}</span>}
    </button>
  );
}
